<template>
  <section>
    <!-- Loading template -->
    <template v-if="loading">
      <Card v-for="n in 3" :key="n">
        <template #content>
          <Grid>
            <Col12>
              <Skeleton />
            </Col12>

            <Col12>
              <Skeleton />
            </Col12>

            <Col12>
              <Skeleton />
            </Col12>
          </Grid>
        </template>
      </Card>
    </template>

    <!-- Main content template -->
    <template v-else>
      <Transition name="fade">
        <div class="c-page-content">
          <slot name="content" />
        </div>
      </Transition>
    </template>
  </section>
</template>

<script setup lang="ts">
import { Card, Col12, Grid, Skeleton } from '../../../../../core';

//  Define props
defineProps({
  loading: {
    type: Boolean,
    default: false,
  },
});
</script>

<style scoped lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
